import VueScrollTo from 'vue-scrollto'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueScrollTo, { offset: -120 })
  return {
    provide: {
      scrollTo: VueScrollTo.scrollTo,
    },
  }
})
